/* ==========================================================================
   Casemira, fiche produit, chantier 1 (vagues 1 et 3)             C1, 2026
   --------------------------------------------------------------------------
   Contrat : SPEC.md points 6 et 8, VAGUE 3 point B.

   Deux choses seulement, et rien d'autre :

   1. La hauteur de la colonne d'informations, ecrite dans `--cm-info-h`.
      Elle sert au `top` collant de la colonne (assets/casemira-pdp-layout.css,
      section 3) : quand la colonne est plus haute que la fenetre, le `top`
      devient negatif et la colonne DEFILE d'abord, puis se cale. Sans ce
      script, `--cm-info-h` vaut 0 et on retombe sur le collant ordinaire du
      thème : aucune regression, seulement moins de finesse.

      La vague 1 mesurait ici le plafond de la photo heros. Ce calcul a disparu
      avec la mosaique : la grille de deux colonnes egales de la vague 3 tient
      entierement en CSS, a partir du ratio de chaque media ecrit cote serveur
      (`--cm-ar`, snippets/product-thumbnail.liquid).

   2. La barre collante mobile. VAGUE 8, point 1 : elle a repris le DESSIN
      D'ORIGINE du thème (vignette, nom, prix, pilule « Ajouter »), et ce
      fichier n'y ecrit plus que DEUX choses :
        - la dimension choisie, sous le nom du produit (l'ajout de la vague 8) ;
        - le prix, recopie du bloc de prix de la colonne, pour qu'il suive le
          format dans le meme tour d'evenement que le tap et non au retour du
          reseau 250 ms plus tard.
      Le libelle « Ajouter au panier · 120 × 170 · 149,00 € » de la vague 5,
      qui remplacait toute la barre par un bouton pleine largeur, est SUPPRIME.

   3. ★ VAGUE 9, point 5 : la barre REVIENT au-dessus de 1000 px, et elle n'est
      plus retiree du DOM. Elle n'y apparait que lorsque le bouton d'ajout de la
      colonne est sorti de l'ecran PAR LE HAUT (observateur d'intersection pose
      sur le bouton lui-meme, et non sur le formulaire comme le fait le thème) :
      tant que la decision d'achat est a l'ecran, il n'y a pas de doublon, donc
      pas de barre. L'observateur du thème est coupe pendant ce temps, et lui est
      rendu sous 1000 px, ou l'apparition d'origine reste celle de la vague 8.

      La vague 5 la retirait pour deux raisons : le doublon, traite ci-dessus, et
      le fait qu'elle se posait par-dessus les carrousels du bas de page. Ce
      second point etait un defaut de DESSIN (une pastille flottante de
      `min(85vw, 41.8rem)` a 3 rem des bords) : elle est maintenant un bandeau
      pleine largeur a fond opaque avec un filet, aligne sur la grille de la
      page (assets/casemira-pdp-layout.css, section 8).

   3b. ★ VAGUE 9, point 3 : la hauteur mesuree de la barre, publiee dans
      `--cm-stickybar-h`, pour que le lanceur du chat se pose au-dessus d'elle
      et non dedans.

   4. VAGUE 5, point 6 : la classe `cm-chat-ready` sur `body`, posee au premier
      defilement (ou au bout de six secondes). Elle seule decide du moment ou le
      lanceur du chat apparait en mobile ; le widget, lui, n'est pas touche.

   Aucune bibliotheque. Charge en defer. N'ecrit jamais dans le formulaire :
   la selection de variante reste au JS du theme (product-info.js) et au
   selecteur de taille.
   ========================================================================== */
(function () {
  'use strict';

  var SECTION = '.section-main-product';

  /* ------------------------------------------------------------------------
     1 · Hauteur de la colonne d'informations
     ------------------------------------------------------------------------ */
  function measureInfo() {
    var section = document.querySelector(SECTION);
    if (!section) return;
    var wrapper = section.querySelector('.product__info-wrapper');
    if (!wrapper) return;
    /* offsetHeight, pas getBoundingClientRect : la valeur ne doit pas dependre
       d'une eventuelle transformation, et l'arrondi entier suffit. */
    var h = wrapper.offsetHeight;
    if (!h) return;
    section.style.setProperty('--cm-info-h', h + 'px');
  }

  /* ------------------------------------------------------------------------
     2 · Barre collante mobile : la dimension choisie, et le prix
     ------------------------------------------------------------------------
     ★ C1 VAGUE 8, point 1.

     Le dessin est celui du thème (snippets/sticky-atc-bar.liquid, style
     « minimalist ») : vignette, nom du produit, prix, pilule « Ajouter ». Il
     n'est PAS reecrit ici. Ce fichier ne fait que deux ajouts, et ils tiennent
     tous les deux dans le meme tour d'evenement que le tap :

       - `.cm-sticky-bar__dim`, une ligne de 12 px sous le nom du produit, qui
         porte la dimension choisie (« 120 × 170 cm ») ;
       - le prix de la barre, recopie du bloc de prix de la colonne.

     Pourquoi RECOPIER le prix au lieu de le calculer. Le bloc de prix de la
     colonne est repeint en synchrone par assets/casemira-size-picker.js
     (vague 7) : il porte deja le bon montant, le bon format monetaire, le bon
     prix barre et la bonne classe `f-price--on-sale`, avant meme que la
     requete reseau ne parte. Le recopier, c'est garantir qu'il n'y aura jamais
     deux prix differents dans la meme page. Recalculer aurait ete une seconde
     source de verite, donc une occasion de se contredire.

     `sticky-atc-bar-minimalist.js` (le thème) reecrit ce meme prix au retour de
     la Section Rendering API. Les deux ecrivent la meme chose ; le premier
     arrive gagne, et c'est celui-ci.
     ------------------------------------------------------------------------ */
  function currentDimension() {
    var scope = document.querySelector(SECTION);
    if (!scope) return '';
    var el =
      scope.querySelector('.dw-picker__row--active .dw-picker__row-dim') ||
      scope.querySelector('.dw-picker__trigger-dim') ||
      scope.querySelector('.dimension-btn.is-selected .dimension-btn__size');
    if (!el) return '';
    var txt = (el.textContent || '').trim();
    if (!txt) return '';
    /* ★ C1 VAGUE 9 : le « x » du selecteur du thème devient le « × » du systeme.
       Mesure du 22/08 sur `tapis-exterieur-camel-dorio` : la barre affichait
       « 200 x 290 cm » la ou la colonne affiche « 200 × 290 cm ». Meme
       normalisation que niceSize() dans assets/casemira-size-picker.js. */
    txt = txt.replace(/(\d)\s*[xX]\s*(\d)/g, '$1 × $2');
    /* Le « cm » est REMIS s'il manque : sur la barre, la dimension est seule
       sur sa ligne, sans le mot « Format » pour la qualifier. « 120 × 170 » ne
       dit pas dans quelle unite ; « 120 × 170 cm » le dit. (La vague 5 le
       retirait, mais elle l'ecrivait dans un libelle de bouton ou la place
       manquait, ce qui n'est plus le cas.) */
    if (!/cm\s*$/i.test(txt)) txt += ' cm';
    return txt;
  }

  function priceBlock(root) {
    return root ? root.querySelector('.f-price') : null;
  }

  /* La ligne de dimension : creee une fois, mise a jour ensuite. Elle se pose
     entre le titre et le prix, c'est-a-dire « sous le nom du produit ». */
  function stickyBarDim(bar) {
    var info = bar.querySelector('.sticky-atc-bar__product-info');
    if (!info) return;
    var title = info.querySelector('.sticky-atc-bar__product-title');
    var dim = currentDimension();

    var el = info.querySelector('.cm-sticky-bar__dim');
    if (!dim) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      el = document.createElement('span');
      el.className = 'cm-sticky-bar__dim';
      if (title && title.nextSibling) info.insertBefore(el, title.nextSibling);
      else info.appendChild(el);
    }
    if (el.textContent !== dim) el.textContent = dim;
  }

  /* Le prix de la barre suit celui de la colonne, a la lettre. On recopie le
     texte des trois emplacements du composant de prix du thème et l'etat
     « en promotion » : rien de plus, rien d'autre. */
  function stickyBarPrice(bar) {
    var src = priceBlock(document.querySelector(SECTION + ' .product__block--price [id^="price-"]'));
    var dst = priceBlock(bar.querySelector('.sticky-atc-bar__product-info'));
    if (!src || !dst) return;

    dst.classList.toggle('f-price--on-sale', src.classList.contains('f-price--on-sale'));
    dst.classList.toggle('f-price--sold-out', src.classList.contains('f-price--sold-out'));

    copyText(src.querySelector('.f-price__regular .f-price-item--regular'),
             dst.querySelector('.f-price__regular .f-price-item--regular'));
    copyText(src.querySelector('.f-price__sale .f-price-item--sale'),
             dst.querySelector('.f-price__sale .f-price-item--sale'));
    copyText(src.querySelector('.f-price__sale s'), dst.querySelector('.f-price__sale s'));
  }

  function copyText(from, to) {
    if (!from || !to) return;
    var txt = from.textContent.replace(/\s+/g, ' ').trim();
    if (to.textContent.replace(/\s+/g, ' ').trim() === txt) return;
    to.textContent = txt;
  }

  function stickyBar() {
    var bar = document.querySelector('sticky-atc-bar-minimalist');
    if (!bar) return;
    stickyBarDim(bar);
    stickyBarPrice(bar);
  }

  /* ------------------------------------------------------------------------
     3 · VAGUE 5, point 2a : pas de barre collante en desktop
     ------------------------------------------------------------------------
     Le seuil est celui de la colonne collante et des badges : 1000 px.
     On garde une reference sur l'element et un marqueur a sa place, pour le
     remettre exactement la ou il etait si la fenetre repasse sous le seuil
     (rotation d'une tablette, fenetre redimensionnee). Rien n'est detruit. */
  var barEl = null;
  var barMark = null;
  var deskObserver = null;
  var deskScrollArmed = false;

  /* ★ C1 VAGUE 9, point 5 : LA BARRE REVIENT EN DESKTOP.
     ------------------------------------------------------------------------
     Elle n'est plus retiree du DOM. Elle change de DECLENCHEUR : le thème
     observe `.main-product-form` avec une marge egale a sa propre hauteur, ce
     qui la fait paraitre des que le formulaire commence a sortir ; le
     proprietaire demande qu'elle ne paraisse qu'une fois le BOUTON D'AJOUT
     sorti par le haut, c'est-a-dire quand la decision d'achat n'est plus a
     l'ecran. On observe donc le bouton lui-meme.

     L'observateur du thème est coupe pendant ce temps : deux sources qui
     basculent la meme classe finiraient par se contredire. Sous 1000 px, on lui
     rend la main telle qu'elle etait (vague 8, decision du proprietaire : c'est
     l'apparition d'origine qui reste en mobile). */
  function addButton() {
    return document.querySelector(SECTION + ' form[data-type="add-to-cart-form"] [name="add"]')
        || document.querySelector(SECTION + ' .main-product-form [name="add"]');
  }

  /* L'observateur d'intersection dit QUAND le bouton entre et sort de la
     fenetre. Il ne dit pas de quel COTE il est sorti : « pas dans la fenetre »
     ne rappelle pas l'observateur quand on passe de « au-dessus » a
     « au-dessous » sans jamais y rentrer, ce qui arrive a chaque retour en haut
     de page un peu vif (mesure du 22/08 : la barre restait affichee a y = 0).
     L'observateur declenche donc l'evaluation, et c'est une mesure directe qui
     tranche. Un ecouteur de defilement, cadence par `requestAnimationFrame`,
     couvre le reste : une lecture de rectangle par image au plus. */
  var deskFrame = 0;

  function desktopEvaluate(bar) {
    var btn = addButton();
    if (!btn) return;
    var above = btn.getBoundingClientRect().bottom <= 0;
    if (bar.classList.contains('sticky-atc-bar--show') !== above) {
      bar.classList.toggle('sticky-atc-bar--show', above);
    }
  }

  function desktopOnScroll() {
    if (deskFrame) return;
    deskFrame = requestAnimationFrame(function () {
      deskFrame = 0;
      var bar = document.querySelector('sticky-atc-bar-minimalist');
      if (!bar || !window.matchMedia('(min-width: 1000px)').matches) return;
      desktopEvaluate(bar);
    });
  }

  function desktopObserverOn(bar) {
    var btn = addButton();
    if (!btn) return;
    if (deskObserver) deskObserver.disconnect();
    if (window.IntersectionObserver) {
      deskObserver = new IntersectionObserver(
        function () {
          desktopEvaluate(bar);
        },
        { threshold: 0 }
      );
      deskObserver.observe(btn);
    }
    if (!deskScrollArmed) {
      deskScrollArmed = true;
      window.addEventListener('scroll', desktopOnScroll, { passive: true });
    }
    desktopEvaluate(bar);
  }

  function stickyBarPresence() {
    var desktop = window.matchMedia('(min-width: 1000px)').matches;
    var live = document.querySelector('sticky-atc-bar-minimalist');

    /* Une barre retiree par une version precedente de ce fichier est remise :
       le retrait de la vague 5 n'a plus lieu d'etre. */
    if (!live && barEl && barMark && barMark.parentNode) {
      barMark.parentNode.replaceChild(barEl, barMark);
      live = barEl;
    }
    if (!live) return;

    if (desktop) {
      try {
        if (live.observer) live.observer.disconnect();
      } catch (e) {}
      desktopObserverOn(live);
      return;
    }

    /* Sous 1000 px : l'apparition d'origine du thème reprend la main. */
    if (deskObserver) { deskObserver.disconnect(); deskObserver = null; }
    if (deskScrollArmed) { window.removeEventListener('scroll', desktopOnScroll); deskScrollArmed = false; }
    try {
      if (live.observer) live.observer.disconnect();
      if (typeof live.init === 'function') live.init();
    } catch (e) {}
  }

  /* ★ C1 VAGUE 9, point 3 : la hauteur REELLE de la barre, publiee pour le CSS.
     Le lanceur du chat se pose 16 px au-dessus d'elle
     (assets/casemira-pdp-layout.css, section 9). La vague 5 ecrivait 56 px en
     dur ; la barre en fait 78,34 depuis que la vague 8 lui a ajoute la ligne de
     dimension, et le lanceur se retrouvait 3,9 px DEDANS. Une hauteur se
     mesure, elle ne se recopie pas. */
  function publishBarHeight() {
    var bar = document.querySelector('sticky-atc-bar-minimalist');
    if (!bar || !document.body) return;
    var h = Math.round(bar.getBoundingClientRect().height);
    if (!h) return;
    if (document.body.style.getPropertyValue('--cm-stickybar-h') !== h + 'px') {
      document.body.style.setProperty('--cm-stickybar-h', h + 'px');
    }
  }

  /* ------------------------------------------------------------------------
     4 · VAGUE 5, point 6 : le lanceur du chat n'arrive qu'apres le premier
         defilement
     ------------------------------------------------------------------------
     On ne touche pas au widget : on pose une classe sur `body`, et
     assets/casemira-pdp-layout.css (section 9) fait le reste. Six secondes de
     secours pour le visiteur qui ne defile pas : le chat doit rester
     joignable. */
  function chatReveal() {
    if (!document.body || !document.body.classList.contains('product-template')) return;
    if (document.body.dataset.cmChatArmed) return;
    document.body.dataset.cmChatArmed = '1';

    /* Deja defile (retour arriere, ancre) : on ne fait pas semblant. */
    if (window.scrollY > 24) {
      document.body.classList.add('cm-chat-ready');
      return;
    }

    var done = false;
    function reveal() {
      if (done) return;
      done = true;
      document.body.classList.add('cm-chat-ready');
      window.removeEventListener('scroll', onScroll);
      clearTimeout(timer);
    }
    function onScroll() {
      if (window.scrollY > 24) reveal();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    var timer = setTimeout(reveal, 6000);
  }

  /* ------------------------------------------------------------------------
     Cycle de vie
     ------------------------------------------------------------------------ */
  /* ★ 25/08 : BADGE « Économisez » SUR LA PHOTO (mobile)
     Le bloc badges est le premier bloc de la colonne d'infos ; sous 750 px il
     tombait sous la photo, decale, comme un element egare (vu par Raph sur
     Terrazzo). Le conteneur d'infos etant collant (position: sticky), un simple
     positionnement absolu ne peut pas l'amener sur la photo : on deplace le
     bloc dans l'enveloppe de la galerie sur mobile, et on le remet a sa place
     sur desktop (au-dessus des etoiles, inchange). Le script du badge cible le
     bloc par attribut, il continue de mettre le pourcentage a jour. */
  var badgeHome = null;
  function badgeOnPhoto() {
    var badge = document.querySelector('.product__block--badges');
    var media = document.querySelector('.product__media-gallery-viewer-wrap') || document.querySelector('.product__media-wrapper');
    if (!badge || !media || !badge.querySelector('*:not(script)')) return;
    var mobile = !window.matchMedia('(min-width: 750px)').matches;
    if (!badgeHome) badgeHome = { parent: badge.parentNode, next: badge.nextSibling };
    if (mobile && badge.parentNode !== media) {
      media.appendChild(badge);
    } else if (!mobile && badge.parentNode === media && badgeHome.parent) {
      badgeHome.parent.insertBefore(badge, badgeHome.next && badgeHome.next.parentNode === badgeHome.parent ? badgeHome.next : null);
    }
  }
  try {
    window.matchMedia('(min-width: 750px)').addEventListener('change', badgeOnPhoto);
  } catch (e) {}

  function applyAll() {
    badgeOnPhoto();
    measureInfo();
    stickyBarPresence();
    stickyBar();
    publishBarHeight();
    chatReveal();
  }

  if (document.readyState !== 'loading') applyAll();
  document.addEventListener('DOMContentLoaded', applyAll);
  window.addEventListener('load', applyAll);

  /* Ordre des evenements sur un changement de variante :
       1. product-info.js dispatche `variant:changed` ;
       2. puis il publie PUB_SUB_EVENTS.variantChange, auquel
          sticky-atc-bar-minimalist.js repond en remettant le libelle court du
          theme sur le bouton de la barre.
     On repasse donc une seconde fois en requestAnimationFrame, apres le theme et
     avant le premier rendu : aucun etat intermediaire n'est visible.

     VAGUE 3 : `event.detail.variant` n'est PAS fiable (product-info.js ne met
     jamais a jour `this.currentVariant` dans handleUpdateProductInfo, il y
     dispatche donc la variante initiale). On ne le lit pas : currentDimension()
     relit la ligne active du selecteur, remise en phase par
     assets/casemira-size-picker.js sur le meme evenement. */
  document.addEventListener('variant:changed', function () {
    stickyBar();
    requestAnimationFrame(stickyBar);
  });

  /* ★ C1 VAGUE 7, point 1 : la barre suit le doigt, pas le reseau.
     `variant:changed` n'arrive qu'au retour de la Section Rendering API (261 a
     272 ms mesures sur iPhone le 22/08). assets/casemira-size-picker.js repeint
     la colonne dans le meme tour d'evenement que le tap et annonce
     `cm:variant:instant` : la barre du bas se remet a jour la, en meme temps
     que le prix du haut, et non un tiers de seconde plus tard. Les deux
     ecoutes coexistent : la seconde ne fait que confirmer la premiere, et
     `copyText()` sort tout de suite si le texte est deja le bon.
     VAGUE 8 : ce qui est mis a jour ici, c'est la ligne de dimension et le
     prix de la barre, pas le libelle du bouton (le thème y ecrit « Ajouter »,
     et c'est tres bien ainsi). */
  document.addEventListener('cm:variant:instant', function () {
    stickyBar();
    /* La ligne de dimension peut faire varier la hauteur de la barre d'un
       pixel selon la police chargee : on republie apres l'ecriture. */
    requestAnimationFrame(publishBarHeight);
  });

  var resizeTimer;
  window.addEventListener(
    'resize',
    function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        measureInfo();
        stickyBarPresence();
        publishBarHeight();
      }, 120);
    },
    { passive: true }
  );

  /* La colonne grandit et retrecit toute seule : accordeon deplie, avis
     Judge.me qui arrivent, badges rendus apres coup. Un ResizeObserver est le
     seul moyen de garder `--cm-info-h` juste sans sonder en boucle.
     Ecrire la variable ne change pas la hauteur observee (elle n'agit que sur
     `top`) : pas de boucle de retroaction. */
  var host = document.querySelector(SECTION);
  var wrapper = host ? host.querySelector('.product__info-wrapper') : null;
  if (wrapper && window.ResizeObserver) {
    var roTimer;
    new ResizeObserver(function () {
      clearTimeout(roTimer);
      roTimer = setTimeout(measureInfo, 60);
    }).observe(wrapper);
  }

  /* Re-rendus de la fiche (changement de variante) : on rejoue, debounce,
     comme casemira-pdp-reskin.js. */
  if (window.MutationObserver && host) {
    var deb;
    new MutationObserver(function () {
      clearTimeout(deb);
      deb = setTimeout(applyAll, 80);
    }).observe(host, { childList: true, subtree: true });
  }
})();
